import { Link } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";
import { ArrowLeft, FileText } from "lucide-react";
import TermsContent from "@/components/legal/TermsContent";

export default function Terms() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/auth" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-8 transition">
          <ArrowLeft className="w-4 h-4" /> {t.legal?.backToHome || "Retour"}
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 grid place-items-center rounded-xl bg-gradient-to-br from-[#FF0050] to-[#8A2BE2]">
            <FileText className="w-5 h-5 text-white" />
          </div>
          <h1 className="text-3xl font-black font-display">{t.legal?.terms || "Conditions d'utilisation"}</h1>
        </div>
        <TermsContent />
      </div>
    </div>
  );
}
